import React from 'react';
import { Button,Label,Input } from 'reactstrap';
import { TableComponent } from './TableComponent';
import { Dialog } from 'primereact/dialog';

export const ModalPrintI = (props) => {

    const { togglePrintI, typeModalPrintI = "viewPrintI", modalPrintI, dataExams,handleCheckProfile, handleCheckAll, Impresionbyexam, loadingDownloadExams, handleCheckAllProfile, letter, handleInputChange, id_workorder_print} = props;

    return (
         <Dialog
            className="pt-0 large-dialog"
            header="Listado de examenes"
            visible={modalPrintI}
            // style={{ width: '60vw', maxWidth: '700px' }}
            modal
            dismissableMask  
            onHide={togglePrintI}
            headerStyle={{
                backgroundColor: '#0d3b59',
                color: 'white',
                fontWeight: 'bold',
                }}
            footer={
                <>
                <hr />
                 <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: '1rem' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <Label>Membretado</Label> <br />
                        <Label className="switch">
                            <Input type="checkbox" name="letter" onChange={handleInputChange} checked={letter} />
                                <span className="slider round"></span>
                        </Label>
                    </div>
                    <Button
                        size='sm'
                        outline
                        color='primary'
                        type='button'
                            onClick={() => Impresionbyexam(id_workorder_print)}

                        disabled={loadingDownloadExams}
                        className={loadingDownloadExams ? "disabled progress-bar-animated progress-bar-striped" : ""}
                    >
                        {loadingDownloadExams ? (
                            <>
                                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                &nbsp; Cargando...
                            </>
                        ) : (
                            "Imprimir"
                        )}
                    </Button>
                    <Button
                        size='sm'
                        className='btn-air-light'
                        outline
                        color='danger'
                        type='button'
                        onClick={togglePrintI}
                    >
                        Cancelar
                    </Button>
                    </div>
                </>
               
                    }
             >
            {
                typeModalPrintI === "viewPrintI" ?
                    <TableComponent
                        key={"table"}
                        indexs={dataExams}
                        handleCheckProfile={handleCheckProfile}
                        handleCheckAll={handleCheckAll}
                        handleCheckAllProfile={handleCheckAllProfile}
                    />                             
                : ""
            }       
        </Dialog>
       
    )
}